import { couponConstants } from '../constants';

export const couponReducer = (state = {}, action) => {
    switch(action.type) {
        case couponConstants.CREATE_COUPON_REQUEST:
            return {
                ...state,
                createCouponProcess: true
            }

        case couponConstants.CREATE_COUPON_SUCCESS:

            return {
                ...state,
                list: {...state.list, [action.payload.userEmail]: action.payload.key},
                createCouponProcess: false,
                createCouponError: false
            }

        case couponConstants.CREATE_COUPON_FAILURE:
            return {
                ...state,
                createCouponProcess: false,
                createCouponError: true
            }

        default: 
            return state;
    }
}

export default couponReducer;


// WEBPACK FOOTER //
// ./src/reducers/coupon.js